const translate = {
    common: {
        login: "Логін",
        password: "Пароль",
        maskedPassword: "**********",
        date: "Дата",
        today: "Сьогодні",
        yesterday: "Вчора",
        currentWeek: "Поточний тиждень",
        currentMonth: "Поточний місяць",
        currentYear: "Поточний рік",
        period: "Період",
        tier: "Рівень",
        save: "Зберегти",
        operators: "Оператори",
        search: "Пошук",
        online: "Онлайн",
        pause: "Пауза",
        offline: "Офлайн",
        chats: "Чати",
        chat: "Чат",
        channels: "Канали",
        type: "Тип",
        token: "Токен",
        enabled: "Увімкнено",
        name: "Назва",
        settings: "Налаштування",
        permissions: "Дозволи",
        contact: "Контакт",
        channel: "Канал",
        accounts: "Акаунти",
        cancel: "Скасувати",
        delete: "Видалити",
        restore: "Відновити",
        merge: "Об'єднати",
        detach: "Відокремити",
        contacts: "Контакти",
        messengers: "Месенджери",
        created: "Створено",
        status: "Статус",
        mailing: "Розсилки",
        start: "Почати",
        message: "Повідомлення",
        analytics: "Аналітика",
        synonyms: "Синоніми",
        export: "Експорт",
        import: "Імпорт",
        publish: "Опублікувати",
        generateQuestions: "Зген. питання",
        generateQuestionsConfirmation: "Генерація питань може призвести до втрати даних. Ви впевнені?",
        answer: "Відповідь",
        active: "Активні",
        inactive: "Неактивні",
        pending: "В очікуванні",
        apply: "Застосувати",
        setting: "Налаштування",
        editAsJson: "Редагувати як json",
        editAsTable: "Редагувати як таблицю",
        image: "Зображення",
        file: "Файл",
        send: "Надіслати",
        close: "Закрити",
        reject: "Відхилити",
        confirm: "Підтвердити",
        setOn: "Встановлено",
        logout: "Вийти",
        wrongPasswordOrLoginOrLicenseMessage: "Помилка авторизації. Перевірте логін і пароль.",
        id: "Ід",
        channelType: "Тип каналу",
        channelName: "Назва каналу",
        chatTag: "Тег",
        telegram: "Телеграм",
        phrase: "Фраза",
        parameters: "Параметри",
        fileSendLikeImageError: "Цей тип зображення можна надіслати лише як файл",
        chatType: "Тип чату",
        messengerExternalId: "Зовнішній ід засоби зв'язку",
        operatorType: "Тип оператора"
    },
    analytics: {
        customerJourney: "Шлях клієнта",
        statistics: "Статистика",
        monitoring: "Моніторинг",
        reports: "Звіти",
        exportReport: "Експорт",
        comeFrom: "Попередній крок",
        dialog: "Діалог",
        wentTo: "Наступний крок",
        getSettingForChartsMessage: "Не вдається завантажити налаштування для діаграм.",
        reportOutOfRangeException: "Неможливо сформувати звіт через обмеження формату файлу.",
        reportException: "Сталася помилка під час вивантаження звіту."
    },
    channels: {
        operatorsForChannel: "Оператори для каналу",
        operator: "Оператор",
        feedback: "Фідбек",
        vip: "ВІП",
        spam: "Спам",
        emptyNameTooltipErrorMessage: "Ім'я не може бути порожнім",
        invalidFieldsMessage: "Деякі поля недійсні",
        channelCreatingErrorMessage: "Будь ласка, збережіть або видаліть новий канал",
        createChannel: "Створити канал",
        sureDeleteChannel: "Ви дійсно хочете видалити канал?",
        saveChannelSuccessMessage: "Збережено успішно",
        saveNewChannelSuccessMessage: "Канал створено успішно",
        saveChannelErrorMessage: "Помилка під час збереження каналу",
        saveNewChannelErrorMessage: "Не зберігається новий канал",
        channelAlreadyExists: "Канал з таким токеном вже існує",
        uniformWidgetStartSignalRError: "Сталася помилка під час підключення до конектора {{url}}",
        deleteChannelSuccessMessage: "Видалено успішно",
        deleteNewChannelSuccessMessage: "Канал не зберігся",
        deleteChannelErrorMessage: "Помилка під час видалення каналу",
        deleteNewChannelErrorMessage: "Канал з ідентифікатором {0} не може бути видалений, оскільки в ньому відкриті чати:",
        copyScriptHeader: "Скрипт скопійовано",
        copyScriptBody: "Скрипт скопійовано в буфер обміну. Використовуйте Ctrl+V, щоб вставити його на свій сайт.",
        telegram: "Телеграм",
        viber: "Вайбер",
        vk: "Вк",
        widget: "Віджет",
        facebook: "Фейсбук",
        weChat: "ВіЧат",
        instagram: "Інстаграм",
        uniformWidget: "Віджет Уніформи",
        ednaWhatsApp: "Ватсап (Edna)",
        whatsApp: "Ватсап",
        voiceChannel: "Голосовий канал",
        devinoWhatsApp: "Ватсап (Devino)",
        restartChannelSuccessMesage: "Канал успішно перезапущено",
        restartChannelQuestion: "Ви впевнені, що хочете перезапустити канал?",
        restartOnlyEnabledChannel: "Канал повинен бути увімкнений"
    },
    chat: {
        transfer: "Переведення",
        transferToOperator: "Переведення на оператора",
        transferToBot: "Переведення на бота",
        transferToGroup: "Переведення на групу",
        invite: "Запросити",
        editMessage: "Редагувати повідомлення",
        doLeaveChat: "Ви хочете вийти з чату?",
        doExportChat: "Ви хочете експортувати чат?",
        exportSuccess: "Чат успішно експортовано",
        exportError: "Експорт до зовнішньої CRM не налаштовано",
        externalCrmOptionsAreNotConfidured: "Налаштування зовнішньої crm не задані",
        export: "Експортувати",
        pause: "Пауза",
        unpause: "Зняти паузу",
        setPauseHeader: "Виберіть категорію паузи",
        removePauseHeader: "Зняти паузу",
        removePause: "Зняти паузу",
        resendMessage: "Переотправити повідомлення",
        setPause: "Поставити на паузу",
        pauseWithoutNotifacation: "Пауза без повідомлення клієнта",
        pauseWithNotifacation: "Пауза з повідомленням клієнта",
        pauseBotChatError: "Неможливо поставити чат з ботом на паузу",
        leave: "Покинути",
        join: "Приєднатися",
        close: "Закрити",
        closeChat: "Закрити чат",
        save: "Зберегти",
        fillInfo: "Заповніть інформацію",
        category: 'Категорія',
        subject: 'Тематика',
        categoryAndSubjectSavedError: 'Для закриття чату заповніть всі поля',
        categoryAndSubjectSavedSuccessfully: 'Категорія і тематика успішно збережені',
        messageDeleted: "Повідомлення видалено",
        messageFileNoEdit: "Повідомлення з файлом/зображенням не можна редагувати.",
        messageFileNoDelete: "Повідомлення з файлом/зображенням не можна видалити.",
        cannotEditMessageWrongChannelType: "Неможливо відредагувати повідомлення. Неправильний тип каналу.",
        sendFileMessageError: "Сталася помилка під час відправки файлу",
        continue: "Продовжити",
        tagSaveError: "Для збереження тегів заповніть обидва поля",
        tagSaveSuccess: "Теги успішно збережені",
        markAsSpam: "Позначити як спам",
        contactHasOpenedChatException: "З цим контактом є відкритий чат. ChatId - {0} Operator - {1}",
        enabledChannelNotFoundException: "Неможливо почати новий чат, оскільки немає увімкненого каналу",
        businessInitiatedTemplateNotFound: "Неможливо почати новий чат, оскільки в каналі немає шаблону стартового повідомлення.",
        chatTypePrivate: 'Особисті повідомлення',
        chatTypeGroup: 'Група',
        chatTypeComment: 'Коментарі',
    },
    chats: {
        my: "Мої",
        withMe: "Зі мною",
        all: "Всі",
        archive: "Архів",
        autoUpdateChat: "Авто-оновлення",
        info: "Інформація",
        statistics: "Статистика",
        closed: "Закрито",
        pause: "ПАУЗА",
        active: "Активний",
        expired: "Закінчився",
        finished: "Завершений",
        missed: "Пропущений",
        chatNumber: "Номер чату",
        chatTag: "Теги чату",
        askYouWannaCloseChat: "Ви хочете закрити чат?",
        askYouWannaJoinChat: "Ви хочете приєднатися до чату?",
        askYouWannaReopenChat: "Ви хочете переоткрити чат?",
        chatOpenedSuccessMessage: "Чат успішно відкрито.",
        chatNotOpenedMessageForSomeReason: "Чат не відкривався. Можливо, з цим контактом вже є відкриті чати.",
        chatNotOpenedMessage: "З цим контактом є відкритий чат. ChatId - {0} Operator - {1}",
        operatorNotAssignedYetMessage: "Ще не призначено",
        openChatErrorMessage: "Щось пішло не так при відкритті чату.",
        continueChatErrorMessage: "Не можу почати чат. Переконайтеся, що канал існує і запущений.",
        editMessageSuccessMessage: "Відредаговано успішно",
        deleteMessageSuccessMessage: "Видалено успішно",
        editMessageErrorMessage: "Не можу відредагувати повідомлення",
        chatAlreadyClosing: "Закриття чату вже в обробці",
        chatClosedSuccessfully: "Чат успішно закрито",
        chatClosedErrorMessage: "Сталася помилка під час закриття чату",
        enterChatName: "Введіть назву чату...",
        messageFromMyself: "Ви",
        messageFromClient: "Клієнт",
        messageFromOperator: "Оператор",
        attachmentMessage: "*вкладення*",
    },
    contact: {
        sureDeleteAccount: "Ви дійсно хочете видалити акаунт?",
        createNewAccounts: "Створити новий акаунт",
        noRecords: "Записів немає",
        invalidFieldsErrorMessage: "Є недопустимі поля",
        phoneNumber: "Номер телефону",
        firstName: "Ім'я",
        lastName: "Прізвище",
        middleName: "По батькові",
        chatName: "Назва чату",
        comment: "Коментар",
        chatsCount: "Кількість чатів",
        locale: "Мова",
        contactCreatingErrorMessage: "Будь ласка, збережіть або видаліть незбережений контакт",
        searchingInputPlaceholder: "пошук за ім'ям, телефоном або назвою чату",
        noContacts: "Немає контактів",
        createContact: "Створити контакт",
        saveContactSuccessMessage: "Збережено успішно",
        saveNewContactSuccessMessage: "Контакт створено успішно",
        saveContactErrorMessage: "Помилка під час збереження контакту",
        saveNewContactErrorMessage: "Не вдається зберегти новий контакт",
        deleteContactSuccessMessage: "Видалено успішно",
        deleteNewContactSuccessMessage: "Видалено успішно",
        deleteContactErrorMessage: "Помилка під час видалення контакту",
        contactFoundMessage: "Контакт знайдено",
        contactNotFoundMessage: "Контакт не знайдено",
        errorSavingAccountWithoutData: "Не вдається зберегти обліковий запис з порожніми полями",
        errorSavingAccountOnlyWithSpaces: "Не вдається зберегти обліковий запис, де поля складаються з пробілів",
        errorSavingAccountCharactersEqualOrMore50: "Не вдається зберегти обліковий запис, де кількість символів у полі перевищує 50 символів",
        errorSavingAccountIdWithSpaces: "Не вдається зберегти обліковий запис, де поле id містить пробіли",
        unsupportedAvatarImageType: "Непідтримуваний тип зображення"
    },
    license: {
        confirmPasswordNotMatchMessage: "Паролі не збігаються!",
        unknownErrorMessage: "Сталася помилка під час активації доступу, зверніться до адміністратора!",
        licenseErrorMessage: "Помилка ліцензії, зверніться до адміністратора!",
        updateLicenseSuccessMessage: "Ліцензія оновлена успішно!",
        updateLicenseErrorMessage: "Помилка оновлення ліцензії!",
        licenseExpiresPart: 'У вас залишилося {{days}} днів ліцензії, зверніться до адміністратора!',
        license: "Ліцензія",
        licenseDetails: "Деталі ліцензії",
        title: "Активація доступу",
        loginLabel: "Логін адміністратора",
        loginPlaceholder: "Логін",
        passwordLabel: "Пароль адміністратора",
        passwordPlaceholder: "Пароль",
        confirmPasswordLabel: "Повторіть пароль",
        confirmPasswordPlaceholder: "Повторіть пароль",
        licenseTitle: "Ліцензія",
        submitButton: "Активувати доступ"
    },
    mailing: {
        createMailing: "Створити розсилку",
        pending: "В очікуванні..",
        inProgress: "В прогресі",
        sent: "Відправлено",
        canceled: "Скасовано",
        allContacts: "Всі контакти",
        balanceBelowZero: "Баланс нижче нуля",
        waitingForConnection: "Очікують підключення",
        sentVia: "Відправлено за допомогою",
        notEnoughSymbolsInMessageError: "Повідомлення занадто коротке.",
        notSelectedChannelError: "Вам потрібно вибрати канал.",
        saveMailingError: "Сталася помилка під час збереження.",
        getMailingByIdError: "Не вдалося отримати розсилку з сервера.",
        startMailingStartMessage: "Почалася розсилка.",
        startMailingSuccessMessage: "Розсилка успішно виконана.",
        startMailingErrorMessage: "Сталася помилка під час відправки розсилки.",
        deleteMailingSuccessMessage: "Видалено успішно",
        deleteMailingErrorMessage: "Сталася помилка під час видалення розсилки.",
        chooseOperator: "Оператор для відправки",
        needChooseOperator: "Потрібно вибрати оператора",
        mailingSaved: "Розсилка успішно збережена"
    },
    nlp: {
        question: "Питання",
        answer: 'Відповідь',
        getScript: "Отримати скрипт",
        createNewTopic: "Створити нову бібліотеку",
        createNewPair: "Створити нову пару",
        topicPairRemoving: "Видалення пари",
        doWantDeleteTopicPair: "Ви хочете видалити пару?",
        selectTarget: "Вибрати ціль",
        transferQuestion: "Перемістити питання",
        move: "Перемістити",
        to: "в",
        askYourQuestion: "Задайте ваше питання",
        unsupportedMessageType: "Непідтримуваний тип повідомлень",
        answerNotFound: "Відповідь не знайдено",
        actualSearchString: "Фактичний рядок пошуку:",
        sureRemoveButton: "Ви дійсно хочете видалити кнопку ",
        buttonType: "Тип кнопки",
        text: "Текст",
        value: "Значення",
        noFoundTopicPair: "Пара тем не знайдена.",
        buttonTextExists: "Кнопка з таким текстом вже існує.",
        newButton: "Нова кнопка",
        buttonEditing: "Редагування кнопки",
        saveTopicSuccessMessage: "Збережено успішно",
        saveTopicErrorMessage: "Помилка під час збереження теми",
        deleteTopicSuccessMessage: "Видалено успішно",
        deleteTopicErrorMessage: "Помилка під час видалення теми",
        exportPairsErrorMessage: "Помилка під час експорту пар",
        importPairsErrorMessage: "Помилка під час імпорту пар",
        importPairsSuccessMessage: "Успішний імпорт пар",
        publishQuestionsSuccessMessage: "Опубліковано успішно",
        publishQuestionsInitializedMessage: "Публікація питань ініційована",
        publishQuestionsErrorMessage: "Помилка під час публікації",
        saveTopicPairSuccessMessage: "Збережено успішно",
        saveTopicPairErrorMessage: "Помилка під час збереження",
        generateQuestionsSuccessMessage: "Питання згенеровані успішно",
        generateQuestionsErrorMessage: "Помилка під час генерації питань",
        synonyms: "Синоніми",
        synonyms_placeholder: "привіт : здрастуйте|салют|хай|здоров\nдобре : відмінно|гуд|круто\nчистий : свіжий|охайний|митий",
        synonyms_fill: 'Заповніть синоніми. Кожне слово з нового рядка, потім двокрапка і його синоніми розділені символом "|"',
        synonyms_needColon: "Відсутня двокрапка між словом і синонімами в рядку \n",
        synonyms_fewColons: "Більше одного роздільника (:) в рядку ",
        synonyms_wrongCharacter: "Недопустимий символ в рядку \n",
        saveSynonymsSuccessMessage: "Синоніми збережені",
        synonym_stopWord: "Помилка. \"{{sw}}\" є стоп словом",
        synonyms_needWord: "Необхідно ввести слово \n",
        synonyms_needSynonyms: "Необхідно ввести синоніми \n",
        pipeMisplacedError: "Символ '|' не може знаходитися до двокрапки \n",
        synonymIsEmpty: "Синонім не може бути порожнім \n",
        deleteTopicPairSuccessMessage: "Успішно видалено",
        deleteTopicPairErrorMessage: "Помилка під час видалення",
        changeTopicPairStatusSuccessMessage: "Відредаговано успішно",
        changeTopicPairStatusErrorMessage: "Помилка зміни статусу пари тем",
        transferQuestionToTopicPairSuccessMessage: "Успішний перенос питання в пару тем",
        transferQuestionToTopicPairErrorMessage: "Помилка під час переносу питання в пару тем",
        messageBoxGetScriptMessage: "Скрипт скопійовано в буфер обміну. Використовуйте Ctrl+V, щоб вставити його на свій сайт.",
        messageBoxGetScriptTitle: "Скрипт",
        messageBoxDeleteTopicMessage: "Ви дійсно хочете видалити бібліотеку?",
        messageBoxDeleteTopicTitle: "Видалення теми",
        theme: "Тема",
        triggerName: "Назва тригера",
        trigger: "Тригер",
        subject: "Тематика",
        source: "Джерело",
        commonParameters: "Загальні параметри",
        topicPairContentType_text: "Текст",
        topicPairContentType_markup: "Розмітка",
        topicPairContentType_video: "Відео",
        topicPairContentType_audio: "Аудіо",
        topicPairContentType_navigation: "Перенаправлення",
        topicPairContentType_textToSpeech: "Автовідтворення",
        errorSendNLPSearchWhenOperatorOffline: "Перейдіть в онлайн або паузу, щоб надіслати повідомлення",
        errorSendNLPSearchWhenChatNotAssigned: "Вибраний чат не прив'язаний до даного оператора",
        messageDontHaveAccessToTopic: "Вибачте, у вас немає доступу до цієї теми",
        questionWithOnlyStopWordsError: "Питання <{{question}}> складається зі стоп слів",
        nlpTopicAlreadyExistsError: "Бібліотека з ім'ям {{topicName}} вже існує",
        aiSearchWithNullConfidenceError: "Сталася помилка під час пошуку за допомогою вектора. Забули опублікувати топік?"
    },
    operators: {
        name: "Ім'я",
        displayName: "Відображуване ім'я",
        createOperator: "Створити оператора",
        sureRemoveOperator: "Ви дійсно хочете видалити оператора?",
        incorrectLoginMessage: "Логін містить недопустимі символи",
        emptyNameTooltipMessage: "Ім'я не може бути порожнім",
        emptyLoginTooltipMessage: "Логін не може бути порожнім",
        emptyPasswordTooltipMessage: "Пароль не може бути порожнім",
        minLengthPasswordMessage: "Пароль повинен бути довшим, ніж ",
        maxLengthPasswordMessage: "Пароль повинен бути коротшим, ніж ",
        minLengthLoginMessage: "Логін повинен бути довшим, ніж ",
        maxLengthLoginMessage: "Логін повинен бути коротшим, ніж ",
        changeAvatarNullIdErrorMessage: "Неможливо змінити аватар не створеного оператора",
        saveOperatorSettingsNullIdMessage: "Неможливо зберегти налаштування не створеного оператора",
        spaceInLoginErrorMessage: "Логін не може містити пробіли",
        operatorCreatingErrorMessage: "Неможливо створити кілька операторів одночасно!",
        uploadScript: "Завантажити",
        saveOperatorNoChangesMessage: "Оператор не змінився",
        saveOperatorSuccessMessage: "Збережено успішно",
        saveOperatorErrorMessage: "Збереження оператора пройшло з помилкою",
        duplicatedOperatorNameErrorMessage: "Оператор з таким ім'ям вже існує",
        duplicatedOperatorLoginErrorMessage: "Оператор з таким логіном вже існує",
        deleteOperatorSuccessMessage: "Видалено успішно",
        cannotDeleteYourself: "Не можна видалити оператора, під яким Ви залогінені",
        deleteOperatorErrorMessage: "Видалення оператора пройшло з помилкою",
        cannotCheckOperatorExists: "Сталася помилка під час спроби перевірити, чи існує користувач з таким логіном",
        logoutOperatorByOperator: "Адміністратор {0} відключив Вас із системи",
        logoutOperator: "Адміністратор відключив Вас із системи",
        setAvatarError: "Сталася помилка під час встановлення аватара",
        setAvatarSuccess: "Аватар успішно оновлено",
        downloadBotScriptError: "Сталася помилка під час вивантаження скрипта бота",
        operatorTypeOperator: "Оператор",
        operatorTypeBot: "Бот",
        operatorTypeSupervisor: "Супервізор",
        operatorTypeHuman: "Людина",
        operatorTypeQueue: "Черга"
    },
    settings: {
        createSettings: "Створити налаштування",
        settingIdCannotBeEmpty: "Неможливо зберегти налаштування з порожнім ідентифікатором.",
        confirmDeleteSetting: "Видалити налаштування",
        confirmDeleteParameter: "Видалити параметр",
        settingIdAlreadyExists: "Налаштування з ідентифікатором {id} вже існує.",
        settingId: "Назва",
        key: "Ключ",
        value: "Значення",
        system: "Система",
        integration: "Інтеграція",
        settingSaved: "Налаштування успішно збережено",
        settingDeleted: "Налаштування видалено"
    },
    chatsPanel: {
        youAreLoggedInAs: "Ви увійшли як ",
        toChangeTheUserPress: "Щоб змінити користувача натисніть ",
        haveBeenAssignedChannels: "Вам були призначені канали: ",
        selectChatMessage: "Будь ласка, виберіть чат.",
        transferChatErrorMessage: "Не можу перевести чат.",
        transferChatSuccessMessage: "Чат переведено успішно.",
        errorReopenChatDueOfflineStatus: "Перейдіть в онлайн, щоб продовжити чат",
        cannotOpenChatInWidgetChannel: "Не вдається відкрити чат у каналі віджета.",
        editMessageWrongChannelTypeMessage: "Неможливо відредагувати повідомлення. Неправильний тип каналу.",
        sendMessageError: "Сталася помилка під час відправки повідомлення",
        sendFileMessageError: "Сталася помилка під час відправки файлу"
    },
    permission: {
        editPermissionsFor: "Змінити дозволи для ",
        tabRole: "Ролі",
        tabUsers: "Користувачі",
        selectUser: "Виберіть користувача",
        Audit_Manage: "Управління аудитом",
        Contacts_Manage: "Управління контактами",
        Chats_ManageOwnChats: "Управління своїми чатами",
        Mailing_Manage: "Управління розсилками",
        Chats_ManageOthersChats: "Управління чужими чатами",
        NLP_Search: "Пошук у базі NLU",
        NLP_Manage: "Управління базою NLU",
        Operators_Manage: "Управління списком операторів і призначення каналів операторам",
        Channels_Manage: "Управління каналами",
        Integrations_Manage: "Управління налаштуваннями інтеграцій",
        CanManageAnalytics: "Робота з аналітикою",
        License_Manage: "Управління ліцензією"
    },
    error: {
        disableWithOpenChats: "Не вдалося оновити канал з ідентифікатором {{channelId, number}}: неможливо відключити канал, якщо відкриті чати: {{openedChats, number}}",
        changeTokenWhenOpenChats: "Не вдалося оновити канал з ідентифікатором {{channelId, number}}: неможливо змінити тип або токен, якщо на каналі є чати.",
        connectionError: "Помилка з'єднання. Спробуйте пізніше.",
        invalidDateMessage: "Невірний формат дати",
        leftDateLessMessage: "Дата зліва менша за дату справа",
        error: "Помилка!",
        channelNotInitialized: "Канал не ініціалізовано",
        invalidTokenErrorMessage: "Будь ласка, авторизуйтесь, щоб продовжити",
        loginFailed: "Помилка авторизації. Перевірте логін і пароль",
        fileEmpty: "Файл порожній і не може бути надісланий.",
        notSendMessageNotChatParticipant: "Неможливо надіслати повідомлення, оскільки оператор не є учасником чату. ChatId: {{chatId, number}} OperatorId: {{operatorId, number}}",
        botBlockedByUser: "Канал заблоковано користувачем. Channel id: {{channelId, number}}, Chat id: {{chatId, number}}",
        instagramUserDisabledMentions: "Упоминаемый користувач відключив можливість його згадувати в налаштуваннях. Удалите згадування і спробуйте ще раз.",
        parentCommentDeleted: "Батьківський коментар видалено автором. Відповідь не може бути надіслано.",
        sendMessageFailed: "Надіслати повідомлення не вдалося. ChatId: {{chatId, number}} OperatorId: {{operatorId, number}}",
        FailedLicenseValidation: "Помилка ліцензії, зверніться до адміністратора!",
        LicenseExpired: "Ліцензія закінчилася, зверніться до адміністратора!",
        LicenseAlreadyActivated: "Ця ліцензія вже активована.",
        UserAlreadyExist: "Користувач з таким логіном вже існує.",
        ChatAlreadyClose: "Чат {{chatId, number}} вже закритий.",
        messageSentOutsideOfAllowedWindow: "Надіслати повідомлення не вдалося. Вийшов 24-годинний період для відповіді після останнього повідомлення клієнта.",
        messageLengthExceeded: "Перевищено допустиму кількість символів. Максимальна довжина повідомлення: {{symbolsCount}} символів.",
    },
    notification: {
        locationText: "Геолокація",
        documentText: "Документ",
        photoText: "Фото",
        newMessageInChat: "Нове повідомлення в чаті ",
        newChatRecieved: "Отримано новий чат!",
        chatId: "ІД чату-",
        connectionError: "Помилка з'єднання!",
        connectionErrorText: "Не вдалося відновити з'єднання, ви будете переведені в статус Offline",
        connectionAbortText: "З'єднання було перервано. Оновіть сторінку для відновлення."
    }
}

export default translate;